/* eslint-disable */
window.addEventListener('load', () => {
    // Control dropdown's on mobile
    const header = document.querySelector('#header'),
        menu_item_parent = header.querySelectorAll('#header .menu-item-has-children');
    if (window.matchMedia('(max-width: 1199px)').matches) {
         // navbar = header.querySelector('.navbar__collapse');
        const video_link = header.querySelector('.video__link'),
            shop_link = header.querySelector('.shop'),
            header_links = document.createElement('div');

        header_links.classList.add('header_links');
        video_link && header_links.insertAdjacentElement('beforeend', video_link);
        shop_link && header_links.insertAdjacentElement('beforeend', shop_link);
        // navbar.insertAdjacentElement('beforebegin', header_links);

        document.addEventListener('click', e => {
            if (!e.target.closest('#main-navigation .menu-item-has-children') && !e.target.closest('.navbar__toggler')) return;
            const closest_element = e.target;

            menu_item_parent.forEach(item => {

                // Koristiti ovu funkciju ako želimo header sa 2 pod nivoa
                // item.classList === closest_element.classList ? closest_element.classList.toggle('open') :
                // (!item.querySelector('.menu-item-has-children.open') ||
                //  item.querySelector('.menu-item-has-children').parentElement.parentElement.classList.contains('open') ?
                //  '' : item.classList.remove('open'));

                // Koristiti ovu funkciju za samo jedan pod nivo
                // item.classList === closest_element.classList ? closest_element.classList.toggle('open') : item.classList.remove('open');
            });
        });

        // window.requestAnimationFrame(() => {
        //     header_scroll(header);
        // });


        document.addEventListener('click', e => {
            if (e.target.closest('#primary-categories')) return;
            if (document.querySelector('#product-categories_wrapper').classList.contains('show')) {
                document.querySelector('#product-categories_wrapper').classList.remove('show');
                document.body.classList.remove('overflow');
            }
        });
    }

    if (window.matchMedia('(min-width: 1200px)').matches) {
        const more_link = header.querySelector('.header-more'),
            fragment = document.createDocumentFragment();

        if (!more_link) {
            return;
        }

        let i = 0;
        for (; i < 3; i++) {
            let el = document.createElement('span');
            el.classList.add('dot');
            fragment.appendChild(el);
        }
        more_link.appendChild(fragment);
    }
});

// function header_scroll(header) {
//     const header_height = header.getBoundingClientRect().top;
//     if ( window.scrollY >= header_height ) {
//         header.classList.add('scrolled');
//         window.requestAnimationFrame(() => {
//             header_scroll(header);
//         });
//
//         return;
//     }
//
//     window.requestAnimationFrame(() => {
//         header_scroll(header);
//     });
// }



// WEBPACK FOOTER //
// ./scripts/modules/header.js